<template>
  <section class="views" @click="schoolNameList = []">
    <headers :isBack="true" title="報名資料"></headers>
    <div class="views_content">
      <div class="views_content_box">
        <ul>
          <li>
            <div class="list2" style="position: relative; padding-bottom: 20px">
              <div class="list2_uls">
                <div class="listLeft">參賽者姓名</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入"
                    v-model.trim="from.username"
                    @blur="onBlurInput()"
                  />
                </div>
              </div>
              <div class="beizhu_2">*須與身份證上的姓名一致</div>
            </div>
          </li>
          <li>
            <div class="list">
              <div class="listLeft">性别</div>
              <div class="listRight">
                <div class="listRight_xuan" @click="sexBut">
                  <span
                    :class="from.sex == '請選擇參賽者性别' ? '' : 'placeholderValue'"
                    >{{ this.from.sex }}</span
                  >
                  <span
                    class="listRight_icon"
                    :class="{ '': true, listRight_icontransform: showPicker }"
                  >
                    <van-icon name="arrow-down" size="12" color="#333333" />
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">手機號</div>
                <div class="listRight">
                  <div class="listRight_sji">
                    <div class="left" @click="pickerPhoneBut">
                      <span>{{ from.code }}</span>
                      <span :class="{ '': true, left_formTwo: showPickerTwo }">
                        <van-icon name="arrow-down" size="12" color="#333333" />
                      </span>
                    </div>

                    <div class="right">
                      <input
                        type="number"
                        placeholder="請輸入"
                        v-model.trim="from.mobilePhone"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="schoolCode" class="beizhu">
                *此號碼僅接收比賽通知，不可登錄App
              </div>
            </div>
          </li>
          <template v-if="!schoolCode">
            <li>
              <div class="list">
                <div class="listLeft">驗證碼</div>
                <div class="listRight">
                  <div class="listRight_sji2">
                    <div class="right">
                      <input
                        type="text"
                        placeholder="請輸入"
                        v-model.trim="from.mobileCode"
                      />
                    </div>
                    <div
                      class="right2"
                      @click="CodeBln ? clickNumberCodeFnc() : ''"
                      v-html="codeMsg"
                    ></div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list">
                <div class="listLeft">電郵</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入"
                    v-model.trim="from.mail"
                  />
                </div>
              </div>
            </li>
          </template>
          <template v-if="schoolCode">
            <li>
              <div class="list2">
                <div class="list2_uls">
                  <div class="listLeft">學生編號</div>
                  <div class="listRight" style="display: flex">
                    <input
                      type="text"
                      placeholder="請輸入學生編號"
                      v-model.trim="from.studentCode"
                    />
                  </div>
                </div>
                <div class="beizhu">*僅用於登錄App，可自定義數字或英文字母</div>
              </div>
            </li>
            <li>
              <div class="list2">
                <div class="list2_uls">
                  <div class="listLeft">登錄密碼</div>
                  <div class="listRight">
                    <input
                      type="text"
                      placeholder="請輸入登錄密碼"
                      v-model.trim="from.password"
                    />
                  </div>
                </div>
                <div class="beizhu">*僅用於登錄App，可自定義數字或英文字母</div>
              </div>
            </li>
          </template>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">年級</div>
                <div class="listRight">
                  <div class="listRight_xuan" @click="schoolBut">
                    <span
                      :class="from.grade == '選擇參賽者年級' ? '' : 'placeholderValue'"
                      >{{ this.from.grade }}</span
                    >
                    <span
                      class="listRight_icon"
                      :class="{
                        '': true,
                        listRight_icontransform: showPickerthree,
                      }"
                    >
                      <van-icon name="arrow-down" size="12" color="#333333" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <!-- 新增：組別 -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">組別</div>
                <div class="listRight">
                  <div class="listRight_xuan" @click="openGroupPicker">
                    <span :class="competitionGroup ? 'placeholderValue' : ''">
                      {{ competitionGroup || "請選擇" }}
                    </span>
                    <span class="listRight_icon">
                      <van-icon name="arrow-down" size="12" color="#333333" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list">
              <div class="listLeft">學校所在地區</div>
              <div class="listRight">
                <div
                  v-if="!schoolCode"
                  class="listRight_xuan"
                  @click="showPickerschool = true"
                >
                  <!-- v-model.trim="from.school_address" -->
                  <span
                    :class="newAddress.length == 0 ? '' : 'placeholderValue'"
                    v-if="newAddress.length != 0"
                    >{{ newAddress[0] }}>{{ newAddress[1] }}</span
                  >
                  <span v-else>請選擇</span>
                  <span
                    class="listRight_icon"
                    :class="{ '': true, listRight_icontransform: showPicker }"
                  >
                    <van-icon name="arrow-down" size="12" color="#333333" />
                  </span>
                </div>
                <div v-if="schoolCode" class="listRight_xuan">
                  <!-- v-model.trim="from.school_address" -->
                  <span
                    :class="newAddress.length == 0 ? '' : 'placeholderValue'"
                    v-if="newAddress.length != 0"
                    >{{ newAddress[0] }}>{{ newAddress[1] }}</span
                  >
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list" style="position: relative; padding-bottom: 20px">
              <div class="listLeft">就讀學校</div>
              <div class="listRight listPan">
                <input
                  v-if="!schoolCode"
                  type="text"
                  placeholder="請輸入"
                  v-model.trim="searchCampus"
                  @click.stop="getHkSchoolList()"
                />
                <input
                  v-if="schoolCode"
                  type="text"
                  placeholder="請輸入"
                  :value="`${searchCampus} ${schoolCode}`"
                  disabled
                />

                <div class="posText" v-if="schoolNameList.length != 0">
                  <ul>
                    <li
                      v-for="(item, index) in schoolNameList"
                      :key="index"
                      @click.stop="zhiyin(item)"
                    >
                      {{ item.schoolName }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="beizhu_2">請注意：請勿輸入中/英文縮寫</div>
            </div>
          </li>
        </ul>

        <div class="school-tip-h5">
          <span class="school-tip-h5__link" @click.stop="goToSchoolInfo">
            學校 / 機構 請點擊登記【學校信息】
          </span>
          <br />如有疑問，請聯絡【人工諮詢】，謝謝！
        </div>
      </div>

      <!-- 性别 -->
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="sexColumns"
          @confirm="onSexConfirm"
          @cancel="showPicker = false"
          confirm-button-text="確認"
        />
      </van-popup>
      <!-- code -->
      <van-popup v-model="showPickerTwo" position="bottom">
        <van-picker
          show-toolbar
          :columns="mobilePhoneColumns"
          @confirm="onPhoneConfirm"
          @cancel="showPickerTwo = false"
          confirm-button-text="確認"
        />
      </van-popup>
      <!-- 年级 -->
      <van-popup v-model="showPickerthree" position="bottom">
        <van-picker
          show-toolbar
          :columns="gradeColumns"
          @confirm="ongradeConfirm"
          @cancel="showPickerthree = false"
          confirm-button-text="確認"
        />
      </van-popup>

      <van-popup v-model="showPickerschool" position="bottom">
        <van-picker
          show-toolbar
          :columns="diqu"
          @cancel="showPickerschool = false"
          @change="onAddressChange"
          @confirm="onAddressConfirm"
          confirm-button-text="確認"
        />
      </van-popup>

      <!-- 組別二級選擇（Vant 兩列） -->
      <van-popup v-model="showGroupPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="groupPickerColumns"
          @change="onGroupPickerChange"
          @confirm="onGroupPickerConfirm"
          @cancel="showGroupPicker = false"
          confirm-button-text="確認"
        />
      </van-popup>

      <div class="fromButtom">
        <img
          :src="require('@/assets/image/hodgepodge/wabutom.png')"
          alt=""
          @click="whatapp"
        />
        <img
          :src="require('@/assets/image/hodgepodge/tijiao.png')"
          alt=""
          @click="Frombuttom"
        />
        <!-- <div class="timeUp">報名已結束</div> -->
      </div>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/custom";
import publics from "@/mixin/public_mixin";
import home from "@/mixin/home_mixin";
import { trackMetaPixel, trackGoogleAdsConversion } from "@/utils/pixel";
export default {
  name: "views",
  data() {
    return {
      showPickerschool: false,
      diqu: [],
      cities: {},
      // 組別選擇
      showGroupPicker: false,
      groupPickerColumns: [{ values: [] }, { values: [] }],
      groupOptions: [
        {
          value: "特殊學校",
          label: "特殊學校",
          children: [{ value: "7", label: "閃亮組" }],
        },
        {
          value: "非華裔",
          label: "非華裔",
          children: [
            { value: "9", label: "飛躍-幼稚園組" },
            { value: "10", label: "飛躍-小學組" },
            { value: "11", label: "飛躍-中學組" },
          ],
        },
        {
          value: "幼稚園",
          label: "幼稚園",
          children: [
            { value: "1", label: "初級組K1-K2" },
            { value: "2", label: "高級組K3" },
          ],
        },
        {
          value: "小學",
          label: "小學",
          children: [
            { value: "3", label: "初級組P1-P2" },
            { value: "4", label: "中級組P3-P4" },
            { value: "5", label: "高級組P5-P6" },
          ],
        },
        {
          value: "中學組",
          label: "中學組",
          children: [{ value: "6", label: "S1-S6" }],
        },
      ],
      from: {
        username: "",
        sex: "請選擇參賽者性别", //-1 未选中  0男  1女
        code: "+852", //区号
        mobilePhone: "", //手机号
        mobileCode: "", //手机验证码
        grade: "選擇參賽者年級", //年级
        mail: "", //邮件
        school_address: "", //地区
        schoolName: "", //就读学校
      },
      showPicker: false,
      showPickerTwo: false,
      showPickerthree: false,

      gradeColumns: [
        "選擇參賽者年級",
        "K1",
        "K2",
        "K3",
        "P1",
        "P2",
        "P3",
        "P4",
        "P5",
        "P6",
        "S1",
        "S2",
        "S3",
        "S4",
        "S5",
        "S6",
        // '飛躍組'
      ], //年级
      competitionGroup: "",
      groupId: "",

      sexColumns: ["請選擇參賽者性别", "男", "女"],
      mobilePhoneColumns: ["+852", "+86"], //区号

      CodeBln: true,
      timer: null, //清空时间
      countdown: 60,
      codeMsg: "獲取驗證碼",

      newAddress: [], //地區
      schoolNameList: [], //提示
      schoolNameShow: true, //點擊
      searchCampus: "",
      disableWatch: false,
      // schoolCode: "",
      // competitionAccountId: "",
    };
  },
  computed: {},
  components: {
    headers,
  },
  watch: {
    newAddress(val) {
      if (val) {
        console.log(val);
        this.schoolNameList = [];
        this.from.schoolName = "";
        this.searchCampus = "";
      }
    },
    searchCampus: {
      immediate: true,
      handler(val) {
        if (!this.disableWatch) {
          this.from.schoolName = "";
          if (this.newAddress.length != 0) {
            if (val.length != 0) {
              this.getHkSchoolList(val);
            } else {
              this.schoolNameList = [];
              this.getHkSchoolList();
            }
          }
        } else {
          this.disableWatch = false;
        }
      },
    },
  },
  created() {
    this.getAddressList();
    // 从地址栏中获取schoolCode参数
    const urlParams = new URLSearchParams(window.location.search);
    const schoolCode = urlParams.get("schoolCode");
    // const competitionAccountId = urlParams.get("id");
    // console.log(schoolCode, competitionAccountId, "schoolCode");
    if (schoolCode) {
      // 在本地存储schoolCode
      this.schoolCode = schoolCode;
      // this.competitionAccountId = competitionAccountId;
      sessionStorage.setItem("schoolCode", schoolCode);
      // sessionStorage.setItem("competitionAccountId", competitionAccountId);
    } else {
      this.schoolCode = sessionStorage.getItem("schoolCode") || "";
      // this.competitionAccountId =
      //   sessionStorage.getItem("competitionAccountId") || "";
    }
    if (this.schoolCode) {
      // 发请求获取对应校区
      this.getSchoolData();
    }
    // this.getSchoolData()

    // 初始化組別二級選擇列
    try {
      const categories = this.groupOptions.map((o) => o.label);
      const firstChildren =
        this.groupOptions[0] && this.groupOptions[0].children
          ? this.groupOptions[0].children.map((c) => c.label)
          : [];
      this.groupPickerColumns = [
        { values: categories, defaultIndex: 0 },
        { values: firstChildren, defaultIndex: 0 },
      ];
    } catch (e) {
      this.groupPickerColumns = [{ values: [] }, { values: [] }];
    }
  },
  mixins: [publics, home],
  mounted() {},
  methods: {
    // 前往學校信息登記
    goToSchoolInfo() {
      let url = "https://edu.chineserd.com/schoolInformation";
      if (window.location.host.indexOf("chineserd") == -1) {
        url = "https://edutest.chineserd.com/schoolInformation";
      }
      window.open(url, "_blank");
    },
    // 組別：打開二級選擇
    openGroupPicker() {
      // 每次打開重建，保險
      try {
        const categories = this.groupOptions.map((o) => o.label);
        const firstChildren =
          this.groupOptions[0] && this.groupOptions[0].children
            ? this.groupOptions[0].children.map((c) => c.label)
            : [];
        this.groupPickerColumns = [
          { values: categories, defaultIndex: 0 },
          { values: firstChildren, defaultIndex: 0 },
        ];
      } catch (e) {
        this.groupPickerColumns = [{ values: [] }, { values: [] }];
      }
      this.showGroupPicker = true;
    },
    // 左列切換時同步右列
    onGroupPickerChange(picker, values, index) {
      if (index === 0) {
        const categoryLabel = values[0];
        const category = this.groupOptions.find(
          (c) => c.label === categoryLabel
        );
        const childrenLabels =
          category && category.children
            ? category.children.map((c) => c.label)
            : [];
        picker.setColumnValues(1, childrenLabels);
      }
    },
    // 確認組別
    onGroupPickerConfirm(values) {
      const [categoryLabel, childLabel] = values;
      const category = this.groupOptions.find((c) => c.label === categoryLabel);
      if (category && category.children && childLabel) {
        const child = category.children.find((x) => x.label === childLabel);
        if (child) {
          this.groupId = child.value;
          this.competitionGroup = child.label;
        }
      }
      this.showGroupPicker = false;
    },
    getSchoolData() {
      let schoolNo =
        this.schoolCode.charAt(0) === "S"
          ? this.schoolCode.slice(1)
          : this.schoolCode;
      const params = {
        schoolNo: schoolNo,
      };
      this.$axios({
        url: this.$api.getSchoolByCode,
        method: "get",
        params: params,
      }).then((response) => {
        const { data } = response.data;
        if (response.data.code == 0) {
          const { schoolRegion, schoolRegion1, schoolName } = data;
          this.newAddress[0] = schoolRegion;
          this.newAddress[1] = schoolRegion1;
          // this.schoolNameList = [{ schoolName }]
          this.disableWatch = true;
          this.from.schoolName = schoolName;
          this.searchCampus = schoolName;
        }
      });
    },
    // 處理ios軟鍵盤彈出頁面被頂上去兼容問題
    onBlurInput() {
      window.scroll(0, 0);
    },
    whatapp() {
      this.home_mdevInit();
      window.open(this.whatUrl, "_blank");
    },
    getQueryString: function (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    zhiyin(e) {
      this.disableWatch = true;
      this.searchCampus = e.schoolName;
      this.$nextTick(() => {
        this.from.schoolName = e.schoolName;
        this.schoolNameList = [];
      });
    },
    onAddressChange(picker, value, index) {
      picker.setColumnValues(1, this.cities[value[0]] || []);
      this.newAddress = value;
    },
    onAddressConfirm(e) {
      console.log(e);
      this.newAddress = e;
      this.showPickerschool = false;
    },
    getAddressList() {
      this.$axios
        .get(this.$api.getHkSchoolRegion)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            let data = res.data.data;
            const cities = data.reduce((result, { title, data }) => {
              result[title] = data;
              return result;
            }, {});
            console.log(cities);
            this.cities = cities;
            const regionKeys = Object.keys(cities);
            const defaultRegion = regionKeys[0];
            this.diqu = [
              {
                values: regionKeys,
              },
              {
                values: cities[defaultRegion] || [],
              },
            ];
          }
        })
        .catch((res) => {
          console.log("失败", res);
        });
    },
    getHkSchoolList(e) {
      let params = {
        schoolRegion: this.newAddress[0],
        schoolRegion1: this.newAddress[1],
        schoolName: e,
      };
      this.$axios({
        url: this.$api.getHkSchool,
        method: "get",
        params: params,
      })
        .then((res) => {
          console.log(res);
          let data = res.data.rows;
          if (res.data.code == 0) {
            this.schoolNameList = [];
            this.schoolNameList = data;
          }
        })
        .catch((res) => {
          console.log("失败", res);
        });
    },
    validator_phone(val) {
      const phone = val;
      return /^[0-9]*$/.test(phone);
    },
    // 验证码
    clickNumberCodeFnc() {
      let { code, mobilePhone } = this.from;
      console.log(code, mobilePhone);
      if (mobilePhone == null || mobilePhone == "") {
        this.$toast.fail("請檢查您的手機號");
        return;
      }

      if (!this.validator_phone(mobilePhone)) {
        this.$toast("手機號格式有誤 !");
        return;
      }
      const phoneList = [];

      // if (code == "+86") {
      //   phoneList.push(mobilePhone);
      // } else {
      //   phoneList.push(code + "-" + mobilePhone);
      // }
      phoneList.push(code + "-" + mobilePhone);
      const params = {
        appType: 12,
        verifyType: 9,
        phoneList,
        smsTemplateType: 10,
        signType: 1,
      };

      this.$toast.loading({
        message: "正在獲取中...",
        forbidClick: true,
        duration: 0,
      });

      this.$axios({
        url: this.$api.sendSmsForSecondCup,
        method: "post",
        data: params,
      })
        .then((response) => {
          if (response.data.code == 0) {
            this.$toast.clear();
            this.$toast.success("驗證碼获取成功");
            let that = this;
            clearInterval(that.timeIntinvel);
            that.CodeBln = false;
            let index = 60;

            that.timeIntinvel = setInterval(() => {
              index--;
              if (index <= 0) {
                index = 0;
                that.CodeBln = true;
                that.codeMsg = "獲取驗證碼";
              } else {
                that.codeMsg = `${index}S`;
              }
            }, 1000);
          } else {
            this.$toast.fail("驗證碼获取失败");
          }
        })
        .catch((error) => {
          this.$toast.clear();
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    // 電郵驗證
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    // 表單
    Frombuttom() {
      // console.log('報名成功')
      let {
        username,
        sex,
        code,
        mobilePhone,
        mobileCode,
        grade,
        mail,
        school_address,
        schoolName,
        studentCode,
        password,
      } = this.from;

      if (username == "" || username == null) {
        this.$toast.fail("請檢查參賽者姓名");
        return;
      }
      if (sex == "請選擇參賽者性别" || sex == -1) {
        this.$toast.fail("請選擇參賽者性别");
        return;
      }
      if (mobilePhone == "" || mobilePhone == null) {
        this.$toast.fail("請輸入參賽者手機號");
        return;
      }

      if (!this.validator_phone(mobilePhone)) {
        this.$toast("手機號格式有誤 !");
        return;
      }
      if (!this.schoolCode) {
        if (mobileCode == "" || mobileCode == null) {
          this.$toast.fail("請輸入驗證碼");
          return;
        }

        if (mail == "" || mail == null) {
          this.$toast.fail("請輸入電郵");
          return;
        }
        if (!this.validator_email(mail)) {
          this.$toast("電郵格式有誤 !");
          return;
        }
      } else {
        if (!studentCode) {
          this.$toast.fail("請輸入學生編號");
          return;
        }
        if (!password) {
          this.$toast.fail("請輸入登錄密碼");
          return;
        }
      }
      if (grade == "選擇參賽者年級" || grade == null) {
        this.$toast.fail("選擇參賽者年級");
        return;
      }
      if (
        this.groupId == "選擇參賽者組別" ||
        this.groupId == null ||
        this.groupId == ""
      ) {
        this.$toast.fail("選擇參賽者組別");
        return;
      }

      if (this.newAddress.length == 0) {
        this.$toast.fail("選擇學校地區");
        return;
      }

      if (schoolName == "" || schoolName == null) {
        this.$toast.fail("請輸入就讀學校");
        return;
      }

      const params = {
        studentName: username,
        sex,
        phone: mobilePhone,
        grade: grade,
        prefix: code.replace(/\+/g, ""),
        email: mail,
        verifyCode: mobileCode,
        studentRegion: this.newAddress[0] + ">" + this.newAddress[1],
        currentSchool: schoolName,
        competitionGroup: this.competitionGroup,
        groupId: this.groupId,
        studentCode,
        password,
        schoolCode: this.schoolCode,
        // competitionAccountId: this.competitionAccountId,
        competitionType: 8,
        platform: !localStorage.getItem("c") ? "H5" : localStorage.getItem("c"),
      };

      console.log("提交", params);
      this.$toast.loading({
        message: "正在提交中...",
        forbidClick: true,
        duration: 0,
      });

      this.$axios({
        url: this.schoolCode
          ? this.$api.signUpByStudentCode
          : this.$api.fromSaveSingle,
        method: "post",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.code == 0) {
            // 根据 platform 参数触发不同埋点
            const platform = localStorage.getItem("c") || "H5";
            if (platform === "100") {
              // Meta Pixel
              trackMetaPixel('CompleteRegistration');
            } else if (platform === "200") {
              // Google Ads 转化事件
              trackGoogleAdsConversion('AW-10986705020/b2mfCIGLta0ZEPyg7_Yo');
            }
            this.$toast.clear();
            this.$toast.success("提交成功");
            this.$router.replace("/successful");
            sessionStorage.setItem("schoolCode", "");
            // sessionStorage.setItem("competitionAccountId", "");
          } else {
            this.$toast.clear();
            this.$toast.fail(response.data.msg);
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.clear();
          this.$toast.fail("error");
          console.log(error);
        });
      // this.$router.push('/successful')
    },
    onSexConfirm(e) {
      console.log(e);
      this.from.sex = e;
      this.showPicker = false;
    },
    sexBut() {
      this.showPicker = true;
    },
    schoolBut() {
      this.showPickerthree = true;
    },
    pickerPhoneBut() {
      this.showPickerTwo = true;
    },
    onPhoneConfirm(e) {
      console.log(e);
      this.from.code = e;
      this.showPickerTwo = false;
    },
    ongradeConfirm(e) {
      console.log(e);
      this.from.grade = e;
      this.showPickerthree = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  //height: 100%;
  height: 100vh;
  // : hidden;
  // width: 100%;
  display: flex;
  flex-direction: column;
  // ovoverflowerflow: hidden;
  // align-items: flex-start;
  // flex-direction: column;
  // justify-content: flex-start;

  .views_content {
    width: 100%;
    height: calc(100vh - 0.8rem);
    padding-bottom: 4rem;
    box-sizing: border-box;
    overflow-x: hidden;
    background: #fafafa;
    position: relative;

    .views_content_box {
      padding: 0.32rem;
      box-sizing: border-box;

      .listRight_sji {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        text-align: right;
        justify-content: flex-end;
        color: #cccccc;
        font-size: 0.28rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;

        .left {
          font-size: 0.28rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          height: 100%;
          display: flex;
          align-items: center;
          position: relative;
          padding-right: 0.32rem;
          box-sizing: border-box;

          span:nth-child(1) {
            font-size: 0.28rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            margin-right: 0.08rem;
          }

          .left_formTwo {
            transform: rotate(180deg);
          }
        }

        .left:after {
          content: " ";
          width: 0.01rem;
          height: 50%;
          background: #cccccc;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }

        .right {
          padding-left: 0.32rem;
          box-sizing: border-box;
          width: 2.5rem;
          height: 100%;
        }
      }

      ul {
        width: 100%;
        padding: 0 0.32rem;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.16rem;
        // overflow: hidden;

        li:last-child {
          border-bottom: none !important;
        }

        li {
          width: 100%;
          border-bottom: 0.02rem solid #f2f2f2;
          display: flex;

          .list {
            width: 100%;
            height: 1.04rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .listLeft {
              font-size: 0.28rem;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .listRight {
              width: 70%;
              height: 100%;
              display: flex;

              input {
                width: 100%;
                height: 100%;
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                border: none;
                text-align: right;
                background: none;
                padding: 0;
                box-sizing: border-box;
              }

              input::-webkit-input-placeholder {
                color: #cccccc;
              }

              /* 使用webkit内核的浏览器 */
              input:-moz-placeholder {
                color: #cccccc;
              }

              /* Firefox版本4-18 */
              input::-moz-placeholder {
                color: #cccccc;
              }

              /* Firefox版本19+ */
              input:-ms-input-placeholder {
                color: #cccccc;
              }

              /* IE浏览器 */

              .listRight_xuan {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;

                .placeholderValue {
                  color: #000000 !important;
                }

                .listRight_icon {
                  margin-left: 0.1rem;
                }

                .listRight_icontransform {
                  transform: rotate(180deg);
                }
              }

              .listRight_sji2 {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;

                .right {
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  position: relative;
                  padding-right: 0.32rem;
                  box-sizing: border-box;
                }

                .right2 {
                  font-size: 0.28rem;
                  font-family: PingFang SC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: #52a1ff;
                  display: flex;
                  align-items: center;
                  width: 2rem;
                  text-align: right;
                  justify-content: space-evenly;
                }

                .right:after {
                  content: " ";
                  width: 0.01rem;
                  height: 50%;
                  background: #cccccc;
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                }
              }
            }

            .listPan {
              position: relative;

              input {
                display: flex;
              }

              .posText {
                position: absolute;
                height: 1px;
                bottom: 0;
                right: 0;
                width: 100%;
                margin: auto;
                z-index: 9;

                ul {
                  width: 100%;
                  padding: 0 !important;
                  box-sizing: 0 1px 3px rgba(31, 35, 40, 0.12),
                    0 8px 24px rgba(66, 74, 83, 0.12);
                  border: 1px solid #f2f2f2;
                  max-height: 4rem;
                  overflow-y: auto;
                  li {
                    height: 0.8rem;
                    line-height: 0.8rem;
                    text-align: left;
                    padding: 0 0.24rem;
                    box-sizing: border-box;
                    cursor: pointer;
                    overflow: hidden;
                    font-size: 0.24rem;
                  }

                  li:hover {
                    background: #52a1ff;
                    color: #ffffff;
                  }
                }
              }
            }
          }

          .list2 {
            width: 100%;

            .list2_uls {
              width: 100%;
              height: 1.04rem;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .listLeft {
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .listRight {
                width: 70%;
                height: 100%;
                display: flex;

                input {
                  width: 100%;
                  height: 100%;
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #000000;
                  border: none;
                  text-align: right;
                  background: none;
                  padding: 0;
                  box-sizing: border-box;
                }

                input::-webkit-input-placeholder {
                  color: #cccccc;
                }

                /* 使用webkit内核的浏览器 */
                input:-moz-placeholder {
                  color: #cccccc;
                }

                /* Firefox版本4-18 */
                input::-moz-placeholder {
                  color: #cccccc;
                }

                /* Firefox版本19+ */
                input:-ms-input-placeholder {
                  color: #cccccc;
                }

                /* IE浏览器 */

                .listRight_xuan {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  text-align: right;
                  justify-content: flex-end;
                  color: #cccccc;
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;

                  .placeholderValue {
                    color: #000000 !important;
                  }

                  .listRight_icon {
                    margin-left: 0.1rem;
                  }

                  .listRight_icontransform {
                    transform: rotate(180deg);
                  }
                }
              }
            }

            .beizhu {
              width: 100%;
              font-size: 0.26rem;
              line-height: 0.3rem;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
              margin-top: 0.16rem;
              text-align: left;
              padding-bottom: 0.18rem;
              box-sizing: border-box;
            }
          }
        }
      }

      .uls_beizhu {
        font-size: 0.26rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #e80202;
        line-height: 0.34rem;
        text-align: left;
        margin-top: 0.32rem;
      }
    }
  }

  .fromButtom {
    position: fixed;
    bottom: 2%;
    left: 0;
    right: 0;
    padding: 0 0.32rem;
    box-sizing: border-box;
    width: 100%;
    // height:300px;
    display: flex;
    justify-content: center;

    img:nth-child(1) {
      width: 131px;
      height: 100%;
      margin-right: 12px;
    }

    img:nth-child(2) {
      width: 200px;
      height: 100%;
    }
    .timeUp {
      width: 200px;
      height: 50px;
      background: #d0d0d0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      box-shadow: 0px 4px 9px 0px rgba(208, 208, 208, 0.4);
      border-radius: 25px;
    }
  }
}

.beizhu_2 {
  position: absolute;
  bottom: 8px;
  width: 100%;
  font-size: 0.26rem;
  line-height: 0.3rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff782f;
  text-align: right;
}

.school-tip-h5 {
  margin-top: 0.32rem;
  font-size: 0.26rem;
  line-height: 0.4rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  text-align: left;

  &__link {
    color: #ff782f;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
